<template>
	<div id="agendaFiltrosGenerales">
		<b-row class="width100" align-h="between" align-v="center">
			
			<b-col lg="4" md="12" class="mt-2 mb-2">
				<b-select v-model="workingValues.cede_id" :options="optionsCedes" @change="updateParent" />
			</b-col>
			
			<b-col lg="8" md="12" v-if="workingValues.cede_id" class="mt-2 mb-2">
				<b-row class="width100" align-h="end" align-v="center">

					<b-col cols="auto">

						<b-button-group v-if="workingValues.editMode">

							<b-button @click="setPastWeek()"> &lt; </b-button>

							<b-button title="Semana seleccionada" v-b-tooltip.hover disabled>
								<strong>Semana seleccionada {{ weekConfigDates.weekNumber }}</strong> <br>
								{{ workingValues.fechas.inicio }} - {{ workingValues.fechas.fin }}
							</b-button>

							<b-button @click="setNextWeek()"> &gt; </b-button>

						</b-button-group>

						<b-input-group v-else>
							<b-form-datepicker v-model="workingValues.fechas.inicio" @hidden="updateParent"
								locale="es" />
							<b-form-datepicker v-model="workingValues.fechas.fin" @hidden="updateParent" locale="es" />
						</b-input-group>
					</b-col>

					<b-col cols="auto hide-on-print">
						<b-form>
							<b-form-checkbox class="pr-2" v-model="workingValues.editMode" 
								@change="updateEmit"
								switch 
								switch-size="lg">
								{{ workingValues.editMode ? 'Edición' : 'Consulta' }}
							</b-form-checkbox>
							<b-form-checkbox v-model="workingValues.filtering" 
								@change="updateEmit"
								switch-size="lg" 
								switch>
								{{ workingValues.filtering ? 'Todos' : 'Activos' }}
							</b-form-checkbox>
						</b-form>
					</b-col>

					<b-col cols="auto hide-on-print" v-if="!workingValues.editMode">
						<b-button @click="triggerPrint">
							<i class="fa fa-print"></i>
						</b-button>
					</b-col>

				</b-row>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UiInputHandler from '../../elements/ui-input-handler'
import _ from "lodash";
import {
	selectFilters,
	loadupPreFilters,
	getWeekConfigDates,
} from "./archetype";
import { notify } from "@/utils.js";

export default {
	components: { UiInputHandler },
	name: "agendaFiltrosGenerales",
	props: {
		value: {
			type: Object,
		},
	},
	computed: {
		optionsCedes() {
			let preFilters = [],
				allItems = _.cloneDeep(this.filters.cedes);

			_.forEach(allItems, (item) => {
				let str = _.replace((item.cede_tipo + ' - ' + item.menu_clase), /_/g, ' ').toUpperCase();
				preFilters.push(str);
				item.str = str;
				return item;
			})

			// PRE FILTERS UNIQ.SORTING
			preFilters = _.uniq(preFilters).sort()

			// CONCAT
			return _.concat(
				{
					value: null,
					text: "REPORTE GENERAL DE COCINA",
				},
				_.map(preFilters, item => {
					return {
						value: item,
						text: item,
						options: _.map(_.filter(_.cloneDeep(allItems), { str: item }), (cede) => {
							return {
								value: cede.id,
								text: cede.cede_titulo.toUpperCase(),
							};
						})
					}
				})
			);
		},
	},
	data: () => {
		return {
			isLoading: false,
			workingValues: _.clone(selectFilters),
			weekConfigDates: getWeekConfigDates(),
			// min: moment().add(-11, 'month').toDate(),
			// max: moment().add(+1, 'month').toDate(),
			filters: {
				cedes: [],
				grupos: [],
				plan: [],
			},
		};
	},
	methods: {
		triggerPrint() {
			window.print();
		},
		setPastWeek() {
			this.weekConfigDates = getWeekConfigDates(
				this.weekConfigDates.mondayDatePast
			);
		},
		setNextWeek() {
			this.weekConfigDates = getWeekConfigDates(
				this.weekConfigDates.nextMondayDate
			);
		},
		updateEmit() {
			setTimeout(this.updateParent, 10)
		},
		updateParent() {
			let newWorkingValue = _.cloneDeep(this.workingValues),
				selectedCEDE = _.find(this.filters.cedes, {
					id: newWorkingValue.cede_id,
				});

			if (selectedCEDE) {
				newWorkingValue.tipo = selectedCEDE.cede_tipo;
			}

			if (newWorkingValue.editMode) {
				newWorkingValue.fechas.inicio = _.clone(this.weekConfigDates.mondayDate);
				newWorkingValue.fechas.fin = _.clone(this.weekConfigDates.fridayDate);
			}

			this.$emit("input", newWorkingValue);
			this.$emit("change", newWorkingValue);
			this.workingValues = newWorkingValue;
		},
		async loadUp() {
			this.isLoading = true;
			try {
				let response = await loadupPreFilters();
				if (!_.isObjectLike(response))
					throw "Error en la consulta o la conexión filtros";
				this.filters = response.data;
			} catch (e) {
				notify(e);
			}
			this.isLoading = false;
		},
	},
	beforeMount() {
		this.weekConfigDates = getWeekConfigDates();
		this.loadUp();
	},
	mounted() {
		if (!this.value) {
			this.updateParent();
		}
	},
	watch: {
		'weekConfigDates.weekNumber'() {
			this.workingValues.editMode = true;
			this.updateParent()
		}
	}
};
</script>

<style lang="less">
#agendaFiltrosGenerales {
	// background: red;
	width: 100%;
}
</style>